import React, { Component } from 'react'

import firebase from '../../server/firebase.js'
import './index.css'

import * as Icon from 'react-feather'

import {Radar} from 'react-chartjs-2'

import ReactStars from 'react-stars'

import logo from '../../assets/userdefault.svg'

import { Modal, Button } from 'react-bootstrap'

import Noty from 'noty'

import Toggle from 'react-toggle'
import './toogle.css'

import ReactPaymentRequest from 'react-payment-request'

import PaypalExpressBtn from 'react-paypal-express-checkout';


// import Tickets from '../Tickets'

// Colocar um novo curso
// firebase.database().ref('cursos/workshop/-LEXpkS-cUnsyxMjy6jK/info').push({
//   title: 'Dia 5 - UX com Protopie',
//   desc: 'A melhor ferramenta de UX de forma descomplicado. Daremos vida ao design feito no Dia 3.'
// })



class Dashboard extends Component {

  constructor(props) {
    super(props)

    this.state = {
      user: '',
      listwork: '',
      dashtype: 'Dashboard',
      show: false,
      loading: true,
      title: 'Treinamento',
      time: '6 meses',
      texto: 'No treinamento você vai aprender sobre a como se tornar um profissional em qualquer área escolhida. As aulas acontecerão nos Sábados e Domingos [Online e Presencial] e ficaram gravadas para os casos de perda e revisão. Além do conteúdo específico de cada área falaremos sobre empreendedorismo e como conseguir fazer capital seja ele com seu próprio trabalho ou através de investimentos. Aproveite tudo isso sem se preocupar em estar sozinho ou com dúvida pois teremos canais para você se sentir a vontade em ter dúvidas e errar com nossos exercícios preparados para você conseguir acompanhar todo o desenvolvimento. Os alunos presenciais terão a possibilidade de apresentar projetos para o fundo de investimento CRIATEC 3, além da possibilidade de contratação para projetos internos da Mouse Labs.',
      presencial: false,
      colorNow: '',
      type: 'workshop',
      price: 500,
      more: 250,
      mes: '',
      cupomNow: '',
      aula: false,
      data : {
        labels: ['Design', 'Front End', 'WEB', 'Mobile'],
        datasets: ''
      },
      details: {
        displayItems: [
          {
            label: "Valor Original",
            amount: { currency: "BRL", value : "1.0" }, // US$65.00
          },
          {
            label: "Desconto Mozi Labs",
            amount: { currency: "BRL", value : "0.0" }, // -US$10.00
            pending: true // The price is not determined yet
          }
        ],
        total:  {
          label: "Total",
          amount: { currency: "BRL", value : "1.0" }, // US$55.00
        }
      },
      methodData : [
        {
          supportedMethods: ["visa", "mastercard", "amex", "diners", "discover", "jcb", 'maestro', 'unionpay', 'visa'],
          data:{
            merchantName: 'Web Payments Demo',
            allowedCardNetworks: ['AMEX', 'MASTERCARD', 'VISA', 'DISCOVER'],
            merchantId: '00184145120947117657',
            paymentMethodTokenizationParameters: {
              tokenizationType: 'GATEWAY_TOKEN',
              parameters: {
                'gateway': 'stripe',
                'stripe:publishableKey': 'pk_live_lNk21zqKM2BENZENh3rzCUgo',
                'stripe:version': '2016-07-06',
              },
          },
        }
        }
      ],
      codigoAgora: '',
      titlenow: 'Treinamento',
      timer: '00:00:00'
    }

    this.treinamento = this.treinamento.bind(this)
    this.workshop = this.workshop.bind(this)
    this.getCourses = this.getCourses.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.buy = this.buy.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.cupom = this.cupom.bind(this)
    this.godMoney = this.godMoney.bind(this)
    this.valueCredit = this.valueCredit.bind(this)
    this.onSuccess = this.onSuccess.bind(this)
    this.tasks = this.tasks.bind(this)
    this.assistir = this.assistir.bind(this)
    this.logout = this.logout.bind(this)
    this.waitForthis = this.waitForthis.bind(this)

    this.getCourses('workshop')

    var reF = this
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        reF.getCourses('workshop')
      }
    });
  }

  handleChange(e) {
    // funcao chamada para alterar todos inputs no component
   this.setState({
     [e.target.name]: e.target.value
   })
  }

  godMoney(event){
    event.preventDefault()

    var value = this.state.price
  }

  getCourses(name){

    console.log("Entrei aqui caralho" + name)
    this.setState({
      loading: true
    })
    var arrayCursos = []

    var refThis = this

    var starCountRef = firebase.database().ref('cursos/'+ name)
    starCountRef.on('value', function(snapshot) {
      // updateStarCount(postElement, snapshot.val())
      var arrayCursos = []
      console.log('Qual foi')

      snapshot.forEach(function(item){

        var val = item.val()
        val.key = item.key

        console.log('toindo')
        console.log(val)
        arrayCursos.push(val)
      })

      // console.log(snapshot.val())

      function iconGet(name){
        if(name== 'Design UI/UX'){
          return <Icon.Layers color="#313131" size={20}/>
        } else if(name== 'Front End') {
          return <Icon.Archive color="#313131" size={20}/>
        } else if (name=='Mobile') {
          return <Icon.Package color="#313131" size={20}/>
        } else if (name=='WEB'){
          return <Icon.Layout color="#313131" size={20}/>
        } else if (name=="Machine Learning"){
          return <Icon.Terminal color="#313131" size={20}/>
        } else if (name=="3D"){
           return <Icon.Move color="#313131" size={20}/>
        } else if (name=="Hardware"){
          return <Icon.HardDrive color="#313131" size={20}/>
        } else if (name=="Matematica"){
          return <Icon.Activity color="#313131" size={20}/>
        }
        else {
          return <Icon.Github color="#313131" size={20}/>
        }
      }


      const listItems = arrayCursos.map((course) =>
      <div class="carousel-cell mobile nobuy" id={course.code}>
        <svg version="1.1" x="0px" y="0px" style={{display: 'none'}}>
          <symbol id="wave">
            <path d="M420,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C514,6.5,518,4.7,528.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H420z"></path>
            <path d="M420,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C326,6.5,322,4.7,311.5,2.7C304.3,1.4,293.6-0.1,280,0c0,0,0,0,0,0v20H420z"></path>
            <path d="M140,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C234,6.5,238,4.7,248.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H140z"></path>
            <path d="M140,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C46,6.5,42,4.7,31.5,2.7C24.3,1.4,13.6-0.1,0,0c0,0,0,0,0,0l0,20H140z"></path>
          </symbol>
        </svg>
        <div class="page" style={{background: course.color}}>
          <div class="water" id="water">
            <svg class="water__wave water__wave_back animated-back" viewBox="0 0 560 20">
              <use xlinkHref="#wave"></use>
            </svg>
            <svg class="water__wave water__wave_front animated-front" viewBox="0 0 560 20">
              <use xlinkHref="#wave"></use>
            </svg>
            <div class="text-page">
              <div className="Icon">{iconGet(course.name)}</div>
              <h4>{course.name}</h4>
              <div class="separator"></div>
              <p>{course.desc}</p>
              <spam>Nível</spam>
              <ReactStars
                count={3}
                size={18}
                value={course.nivel}
                color2={'#ffd700'} />
              <button className="assistir" onClick={refThis.waitForthis}>Assistir</button>
              <button className="BUY" onClick={refThis.buy.bind(this, course)}>Comprar</button>
            </div>
            <div class="water__inner">
              <div class="bubble bubble_1"></div>
              <div class="bubble bubble_2"></div>
              <div class="bubble bubble_3"></div>
            </div>
          </div>
        </div>
        <p className="para-buble">{course.data}</p>
        <spam className="pre">Presencial</spam>
      </div>
      )

      refThis.setState({
        listwork: listItems,
        loading: false
      }, () => {
        var user = firebase.auth().currentUser.uid
        var pai = firebase.database().ref('users/' + user + '/cursos')
        var arrayCursos2 = []

        pai.once('value', function(snapshot) {
          // console.log(snapshot)
          // console.log(snapshot.val())
          snapshot.forEach(function(item){

            var obj = {}
            obj.val = item.val()
            obj.key = item.key

            console.log(obj)
            // console.log(val)
            var element = document.querySelector('#'+obj.key)


            if(element){
              element.classList.add(obj.val.type);
            }

            // var button = element.querySelector('.BUY')
            // console.log(button.value)
            // button.innerHTML = "Assistir"
            // button.onClick = refThis.waitForthis()
          })
          // console.log(arrayCursos)
        })
    })

    })
  }

  waitForthis(){
    this.setState({
      aula: true
    })

    var refThis = this
    var data = new Date();

    var newdata = new Date("June 23, 2018 19:00:00");
    console.log(data)
    console.log(newdata)
    console.log(data.getTime())
    console.log(newdata.getTime())
    var newDatanow = (newdata.getTime() - data.getTime())

    console.log(newDatanow)

    function msToTime(duration) {
      var milliseconds = parseInt((duration % 1000) / 100),
      seconds = parseInt((duration / 1000) % 60),
      minutes = parseInt((duration / (1000 * 60)) % 60),
      hours = parseInt((duration / (1000 * 60 * 60)) % 24);

      hours = (hours < 10) ? "0" + hours : hours;
      minutes = (minutes < 10) ? "0" + minutes : minutes;
      seconds = (seconds < 10) ? "0" + seconds : seconds;

      return hours + ":" + minutes + ":" + seconds
    }

    function convertMS( milliseconds ) {
    var day, hour, minute, seconds;
    seconds = Math.floor(milliseconds / 1000);
    minute = Math.floor(seconds / 60);
    seconds = seconds % 60;
    hour = Math.floor(minute / 60);
    minute = minute % 60;
    day = Math.floor(hour / 24);
    hour = hour % 24;

      hour = (day*24) + hour
      return hour + ":" + minute + ":" + seconds
    }

  newDatanow = (newDatanow * -1)

  var valor = convertMS(newDatanow)
  refThis.setState({
    timer : valor,
    seconds : newDatanow
  })

  function tick(){

    var valorNow = refThis.newDatanow
    valorNow = valorNow - 1
    var valor = convertMS(valorNow)

    refThis.setState({
      timer : valor,
      seconds : valorNow
    })
  }

  setInterval(tick, 1000);


  }

  componentDidMount() {
    this.getCourses('workshop')

    const script = document.createElement("script")

    script.src = "https://storage.googleapis.com/prshim/v1/payment-shim.js"
    script.async = true

    document.body.appendChild(script)

    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.setState({
          mobile: true
        })
    }
  }

  buy(course){

    var arrayInfo = []
    var listItems = ''

    var refThis = this

    var infoRef = firebase.database().ref('cursos/'+ this.state.type +'/' + course.key + '/info')

    var infoRef2 = firebase.database().ref('cursos/'+ this.state.type + '/-LEb9BKQicKVak2BQV9x/info')


    infoRef.once('value', function(snapshot) {

      snapshot.forEach(function(item){

        var val = item.val()
        val.key = item.key

        arrayInfo.push(val)
      })

      // Putaria das grandes
      // infoRef2.set(snapshot.val())

      console.log(arrayInfo)

      const listItems = arrayInfo.map((info) =>
        <div className="info-section">
          <spam>{info.title}</spam>
          <p>{info.desc}</p>
        </div>
      )

      refThis.setState({info: listItems})
    })

    this.setState({
      show: true,
      colorNow: course.cardColor,
      title: course.name,
      subtitle: course.desc,
      desc: course.descT,
      data: course.data,
      hora: course.hora,
      code: course.code
    })
  }

  logout(){

    this.setState({
      listwork: ''
    })

    firebase.auth().signOut().then(function() {

    }).catch(function(error) {

    });

  }


  valueCredit(valor, desconto){


    this.setState({
      details:
      {
        displayItems: [
          {
            label: "Valor Original",
            amount: { currency: "BRL", value : "1.0" }, // US$65.00
          },
          {
            label: "Desconto Mozi Labs",
            amount: { currency: "BRL", value : "0.0" }, // -US$10.00
            pending: true // The price is not determined yet
          }
        ],
        total:  {
          label: "Total",
          amount: { currency: "BRL", value : "1.0" }, // US$55.00
        }
      }
    })
  }

  treinamento(){

    // this.setState({
    //   dashtype: 'DashBoard Treino',
    //   listwork: '',
    //   title: 'Treinamento',
    //   time: '6 meses',
    //   texto: 'Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Donec sed odio dui. Aenean lacinia bibendum nulla sed consectetur. Curabitur blandit tempus porttitor. Maecenas faucibus mollis interdum.',
    //   type: 'treinamento',
    //   price: 500,
    //   more: 300,
    //   mes: '6x'
    // })

    new Noty({type: 'warning',layout: 'topRight',text: 'Em breve'}).show()

    // this.getCourses('treinamento')
  }

  workshop(){

    // this.setState({
    //   dashtype: 'DashBoard',
    //   listwork: '',
    //   title: 'WorkShop',
    //   time: 'Uma semana',
    //   texto: 'Perfeito para quem quer ter uma base para iniciar nas areas, ou quem quer experimentar uma nova area. Aulas acontecem ao vivo, mas podem ser acompanhadas a qualquer momento, pelo sistema durante o periodo de 1 ano apos a compra',
    //   type: 'workshop',
    //   price: 500,
    //   more: 250,
    //   mes: ''
    // })
    this.getCourses('workshop')
  }


  handleClose(){

    var type = this.state.type

    if(type == 'workshop') {
      this.setState({
        show: false,
        presencial: false,
        aula: false,
        price: 500,
        cupomAdd: false
      })
    } else {
      this.setState({
        show: false,
        aula: false,
        presencial: false,
        price: 500,
        cupomAdd: false
      })
    }
  }

  _handleToogle(e,value){

    var newValue = !(this.state[value])
    var refThis = this
    var priceNow = this.state.price
    var more = this.state.more

    if(newValue){
      this.setState({
        price: 750,
        [value]: newValue,
        cupomAdd: ''
      })
    } else {
      this.setState({
        price: 500,
        [value]: newValue,
        cupomAdd: ''
      })
    }
  }

  cupom(event){
    event.preventDefault()

    var refCupom = firebase.database().ref('cupom/' + this.state.cupom)
    var refThis = this

    refCupom.once('value', function(snapshot) {
      if(snapshot.val()){
        // console.log(snapshot.val())
        var percent = snapshot.val()

        refThis.setState({
          cupomNow: snapshot.key
        })

        var price = refThis.state.price
        var newPrice = (price - (price * (percent/100)))

        if(refThis.state.cupomAdd){
          new Noty({type: 'error',layout: 'topRight',text: 'Ja foi adicionado um cupom'}).show()
        } else {
          refThis.setState({
            price: newPrice,
            cupomAdd: true
          })
          new Noty({type: 'success',layout: 'topRight',text: 'Cupom adicionado'}).show()
        }
      } else {
        new Noty({type: 'error',layout: 'topRight',text: 'Cupom não encontrado'}).show()
      }
    })
  }

  tasks(){
    // this.setState({
    //   listwork : <Tickets/>,
    //   titlenow: 'Tarefas',
    //   time: '',
    //   texto: 'Crie e receba tarefas dos instrutores. Os pontos são obtidos somente através das tarefas dadas pelos intrutores.'
    // })
    new Noty({type: 'warning',layout: 'topRight',text: 'Em breve :)'}).show()
  }

  keepcalm(){
    new Noty({type: 'warning',layout: 'topRight',text: 'Em breve :)'}).show()
  }

  pagamentoFeito(){
    var codigoCurso = this.state.codigoAgora
    var userUID = firebase.auth().currentUser.uid
    var refFirebase = firebase.database().ref(userUID + '/acesso/' + codigoCurso)

    refFirebase.set(true)
  }

  onSuccess(payment){
    new Noty({type: 'success',layout: 'topRight',text: 'Compra feita'}).show()
    this.setState({
      show: false
    })

    var user = firebase.auth().currentUser.uid
    var code = this.state.code
    console.log(user)

    var price = this.state.price

    // if(price > 500){
    //   firebase.database().ref('users/' + user + '/'+ code).set('presencial')
    // } else {
    //   firebase.database().ref('users/' + user + '/'+ code).set('online')
    // }

    var userId = firebase.auth().currentUser.uid
    var paymentId = payment.id
    var urlFunc = 'https://us-central1-curso-ml.cloudfunctions.net/paymentAuth?'
    var urlFinal = urlFunc + 'userId=' + userId + '&payId=' + paymentId;

    window.location = urlFinal
  }

  onCancel(){
    new Noty({type: 'error',layout: 'topRight',text: 'Compra cancelada'}).show()
  }

  assistir(){

    this.getCourses('workshop')
    this.setState({
      titlenow: 'Treinamento',
      time: '1 Semana',
      texto: 'No treinamento você vai aprender sobre a como se tornar um profissional em qualquer área escolhida. As aulas acontecerão nos Sábados e Domingos [Online e Presencial] e ficaram gravadas para os casos de perda e revisão. Além do conteúdo específico de cada área falaremos sobre empreendedorismo e como conseguir fazer capital seja ele com seu próprio trabalho ou através de investimentos. Aproveite tudo isso sem se preocupar em estar sozinho ou com dúvida pois teremos canais para você se sentir a vontade em ter dúvidas e errar com nossos exercícios preparados para você conseguir acompanhar todo o desenvolvimento. Os alunos presenciais terão a possibilidade de apresentar projetos para o fundo de investimento CRIATEC 3, além da possibilidade de contratação para projetos internos da Mouse Labs.',
    })
  }

  render() {

    const client = {
  			sandbox:    'AS8zdi2YbDX1RiAaGlsf_q-t79qasfDexl1f0s8Cb5E4lS-Qq4saeooiJBbct2-9NHyawP4fToYzp0P0',
  			production: 'AVQxv2E6YE7y0b7XRd8u-KNBqk__lc-SevA7TmwR-S5fsuWz7qQX20iyjydEViL_sfayu7sKl0xmYRPC',
  		}

    const {title, subtitle, desc, data, hora, info, mobile} = this.state

    var userEmail = ''
    var userPhoto = logo

    const {show} = this.state

    var mobileScreen = ''

    if(mobile){
      mobileScreen = (<div className="MobileFirst">
        <h1>Estamos em Beta por esse motivo ainda não temos o DashBoard em Mobile</h1>
        <p>Você vai precisar de um computador para assistir as aulas...</p>
        <a className="back-mouse" href="https://mouselabs.com.br"></a>
      </div>)
    }

    if(firebase.auth().currentUser){
      userEmail = firebase.auth().currentUser.displayName
      userPhoto = firebase.auth().currentUser.photoURL
      if(userPhoto == null){
        userPhoto = logo
      }
    }

    var loading = this.state.loading

    var classLogin = ''

    if(loading){
      classLogin = 'loading visible'
    }else {
      classLogin = 'loading'
    }

    const onSuccess = (payment) => {
            // Congratulation, it came here means everything's fine!

            		// You can bind the "payment" object's value to your state or props or whatever here, please see below for sample returned data
            // console.log(payment.paymentID)
      var userId = firebase.auth().currentUser.uid
      var paymentId = payment.paymentID
      var urlFunc = 'https://us-central1-curso-ml.cloudfunctions.net/paymentAuth?'

      var code = this.state.code
      var cupom = this.state.cupomNow

      var type = 'online'
      var price = this.state.price

      if(price > 500){
        type = 'presencial'
      }

      var urlFinal = urlFunc + 'userId=' + userId + '&payId=' + paymentId + '&course=' + code + '&cupom=' + cupom + '&type=' + type;

      console.log(payment)

      window.location = urlFinal
    }


    return (
      <div className={this.state.dashtype}>
        {mobileScreen}
        <div className="Dash-SideBar">
          <div className="Dash-Logo Logo-Marca"></div>
          <div className="Dash-Menu">
            <div onClick={this.assistir} className="Dash-Menu-Icon Dash-Menu_selected"><div><Icon.Monitor color="#313131" size={17}/></div><p className="tooltip">Assistir<spam>Assistir suas aulas e poder comprar os cursos</spam></p></div>
            <div onClick={this.tasks} className="Dash-Menu-Icon"><div><Icon.Clipboard color="#313131" size={15}/></div><p className="tooltip">Tarefas<spam>Tarefas destinadas aos alunos para eles pontuarem</spam></p></div>
            <div onClick={this.keepcalm} className="Dash-Menu-Icon"><div><Icon.Briefcase color="#313131" size={15}/></div><p className="tooltip">Oportunidades<spam>Empresas e investidores interessados em nossos alunos</spam></p></div>
            <div onClick={this.keepcalm} className="Dash-Menu-Icon"><div><Icon.Slack color="#313131" size={15}/></div><p className="tooltip">Comunicação<spam>Canais de comunicação com os outro alunos e grupos específicos sobre os assuntos</spam></p></div>
          </div>
          <div className="Dash-Logout" onClick={this.logout}><Icon.LogOut color="#313131" size={15} /></div>
        </div>
        <div className="Dash-SubSideBar">
          <div className="Dash-WorkShop Sub-Selected" onClick={this.workshop}>T</div>

          <div className="Dash-Out" onClick={this.treinamento}></div>
        </div>
        <div className="DashBoard-Courses">
          <div className="Dash-List">
            <div className="Dash-Title">Dashboard Mouse Labs</div>
            <div className="List-Info"><h1>{this.state.titlenow}<spam> {this.state.time} <Icon.Clock color="#313131" size={12}/></spam></h1></div>

            <div className="List List-Work">
              <div className="List-Work_nice">
                <div class={classLogin}>
                  <div class="col-sm-2">
                    <div class="sp sp-wave"></div>
                  </div>
                </div>
                {this.state.listwork}
              </div>
              <div className="List-Info_Desc">
                <p>{this.state.texto}</p>
                <div className="Features">
                <div><Icon.Award color="#313131" size={13}/> - Certificado</div>
                <div><Icon.Video color="#313131" size={13}/> - Assistir qualquer hora</div>
                <div><Icon.Slack color="#313131" size={13}/> - Comunidade</div>
                <div><Icon.Briefcase color="#313131" size={13}/> - Oportunidade de emprego</div>
                <div className="Only-Treino"><Icon.Briefcase color="#313131" size={13}/> - Oportunidade de emprego</div>
                <div className="Only-Treino"><Icon.Sunrise color="#313131" size={13}/> - Apresentar para investidores</div>
                <div className="Only-Treino"><Icon.ShoppingBag color="#313131" size={13}/> - Desconto proximos cursos</div>
                <div className="Only-Treino"><Icon.Book color="#313131" size={13}/> - Conteudo escrito</div>
                </div>
              </div>
            </div>
            <div className="List-Treino">
            </div>
          </div>
          <div className="Dash-Perfil">
            <p>Perfil</p>
            <img className="Dash-Perfil_Photo" src={userPhoto} align="middle"></img>
            <div className="Dash-Perfil_Email">{userEmail}</div>
            <p>Aluno desde --/--/--</p>
            <Radar width={80} height={100} data={this.state.data} legend={false}/>
            <spam className="Dash-Perfil_Info">Os pontos são obtidos pelos exercícios e acompanhamento das aulas</spam>
          <a href=""></a>
          </div>
        </div>
        <Modal className="Modal-Money" show={show} onHide={this.handleClose}>
          <Modal.Header>
            <div className="WTF FlexBetweenHeader">
              <div className="CloseModal" onClick={this.handleClose}>
                <Icon.X/>
              </div>
            </div>
            <div className="Money-Title">
              <Modal.Title>Finalizar Compra</Modal.Title>
              <div className="Modal-Money_price">
                <spam>Mensalidade {this.state.mes}</spam>
                <p>R$ {this.state.price},00</p>
              </div>
            </div>
          </Modal.Header>

            <Modal.Body>
              <div className="Modal-Money_card" style={{background: this.state.colorNow}}>
                <div className="Title-Money">{title}</div>
                <div className="SubTitle-Money">{subtitle}</div>
                <div className="Ho-Money">
                  <div>
                    <h3>Tempo</h3>
                    <p>{data}</p>
                  </div>
                  <div>
                    <h3>Horário Aula [Ao vivo]</h3>
                    <p>{hora}</p>
                  </div>
                </div>
              </div>
              <div className="Modal-Money_info" >
                {this.state.info}
                {/* <a href="https://outbas.com" target="_blank"><button className="bolsa">BOLSA DE ESTUDOS</button></a> */}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <p>Vale ressaltar que a perda de qualquer aula, tanto os compradores online como presenciais podem rever as aulas quando quiser pelo sistema. As aulas começaram dia 9 de Feveireiro e acontecerão Ao vivo mas poderá ser acompanhada quando quiser com acesso de 1 ano pelo sistema.</p>
              <div className="Presencial">
                <Toggle
                    aria-labelledby='header-Show'
                    value={this.state.presencial}
                    defaultChecked={this.state.presencial}
                    onChange={(e)=>this._handleToogle(e,'presencial')}/>
                  <spam>Presencial +{this.state.more}</spam>
                  <spam className="local">Brasilia DF - Vision Hplus ao lado do Conjunto Nacional</spam>
              </div>
              <form onSubmit={this.cupom} className="Cupom">
                <input type="text" placeholder="CUPOM" name="cupom" value={this.state.cupom} onChange={this.handleChange} required/>
              <button type="submit" className="aplicar">Aplicar cupom</button>
              </form>
              <div className="btns-payment">
              <div className="">
              </div>
              {/* this.state.price */}
              <PaypalExpressBtn env={'production'} client={client} currency={'BRL'} total={this.state.price} onSuccess={onSuccess} onCancel={this.onCancel}/>
              <a className="duvida" href="https://youtu.be/l8v1j4iiWLo" target="_blank">Em dúvida ainda</a>
              </div>
            </Modal.Footer>
        </Modal>
        <Modal show={this.state.aula} onHide={this.handleClose} className="Modal-Aula">
          <Modal.Header>
            <div className="WTF FlexBetweenHeader">
              <div className="CloseModal" onClick={this.handleClose}>
                <Icon.X/>
              </div>
            </div>
          </Modal.Header>
          <form>
            <Modal.Body>

              <div className="Aula">
                <div className="Logo-ML"></div>
                {/* <h1>{this.state.timer}</h1> */}
                <h1>09 de Fevereiro 2018</h1>
                <p>Início das aulas</p>
                <spam>Pronto para dominar tanto poder?</spam>
              </div>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
          </form>
        </Modal>
        <div className="methods">
          <spam>Boleto ou Transferência</spam>
        </div>
      </div>
    )
  }
}
export default Dashboard

// <button id="paypal"></button>
// <div className="Dash-Treinamento" onClick={this.treinamento}>T</div>



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js